var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('nav',[_c('router-link',{attrs:{"to":"/"}},[_vm._v("home")]),_c('span',{staticClass:"pipe"},[_vm._v("|")]),_c('router-link',{attrs:{"to":"/portfolio"}},[_vm._v("portfolio")])],1),_c('router-view',{staticClass:"body"}),_c('footer-component',{staticClass:"footer"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }